import { connect } from 'react-redux';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import {
  clearAcl,
  fetchAcl,
  fetchOrgMembers,
  loadMyTeams,
  setError,
  setPipelineAction,
  shareDatasetAndFetch,
  unshareDatasetAndFetch,
  updateAcl,
} from 'js/actions';
import { isReadOnly } from 'js/lib/ACLUtils';
import { getCurrentUser } from 'js/reducers/session';
import { ACL_RESOURCE_TYPE_DATASET } from 'js/constants/aclConstants';
import {
  GET_ACL_REQUEST,
  GET_DATA_SET_REQUEST,
  SHARE_DATASET_REQUEST,
  UNSHARE_DATASET_REQUEST,
  UPDATE_ACL_REQUEST,
} from 'js/constants/actionTypes';

import AclTabView from './AclTabView';
import { isFlowNodeResource } from 'js/lib/ResourceUtils';
import { transferFlowOwnership } from 'new/components/collaborate/TransferFlowOwnership/transferFlowOwnership';
import { showAlert } from 'new/stores/showAlert/action';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { orgs, teams, flowNodes, users },
    teams: { myTeamsSortedIds },
    request,
    acl: { byKey },
    orgs: { orgMembers },
  } = state;

  const { data, resourceType } = ownProps;
  const isFlowNode = isFlowNodeResource(resourceType, data);
  const flow = flowNodes[data.origin_node_id ?? (isFlowNode ? data?.id : undefined)];
  const currentUser = getCurrentUser(state);

  const isLoading = request[GET_ACL_REQUEST] || false;
  const isSaving =
    request[UPDATE_ACL_REQUEST] ||
    request[SHARE_DATASET_REQUEST] ||
    request[UNSHARE_DATASET_REQUEST] ||
    request[GET_DATA_SET_REQUEST] ||
    false;
  let aclItems = [];
  let datasetAclItems = [];

  if (byKey[`${resourceType}${data.id}`]) {
    aclItems = byKey[`${resourceType}${data.id}`];
  }

  if (byKey[`${ACL_RESOURCE_TYPE_DATASET}${data.id}`]) {
    datasetAclItems = byKey[`${ACL_RESOURCE_TYPE_DATASET}${data.id}`];
  }

  const userOrg = orgs[currentUser.org];

  const orgMembership =
    userOrg && has(userOrg, 'id') && !isNil(orgMembers[userOrg.id]) ? orgMembers[userOrg.id] : null;

  return {
    flow,
    ownerUser: users?.[data.owner_id ?? data.owner?.id ?? data.owner],
    isLoading,
    isSaving,
    aclItems,
    datasetAclItems,
    readOnly: (data && isReadOnly(data)) || false,
    currentUser,
    userOrg,
    orgMembership,
    userTeamIds: myTeamsSortedIds,
    orgs,
    teams,
  };
};

export default connect(mapStateToProps, {
  fetchAcl,
  updateAcl,
  clearAcl,
  shareDatasetAndFetch,
  unshareDatasetAndFetch,
  loadMyTeams,
  fetchOrgMembers,
  setPipelineAction,
  setError,
  transferFlowOwnership,
  showAlert,
})(AclTabView);
